import React from 'react';
import { Typography, Paper, Grid, Divider, Link as MuiLink } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const ServiceDetailInfo = ({ serviceRecord }) => {
    return (
        <Paper sx={{ p: 2 }}>
            <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} sm={6}>
                    <Typography variant="h6" gutterBottom>Müşteri Bilgileri</Typography>
                    <Divider sx={{ my: 1 }} />
                    <MuiLink
                        component={RouterLink}
                        to={`/musteri/${serviceRecord.musteriId}`}
                        sx={{ textDecoration: 'none', color: 'inherit', fontWeight: 'bold' }}
                    >
                        {serviceRecord.musteriAdSoyad}
                    </MuiLink>
                    <Typography><b>Telefon:</b> {serviceRecord.musteriTelefon}</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Typography variant="h6" gutterBottom>Cihaz Bilgileri</Typography>
                    <Divider sx={{ my: 1 }} />
                    <MuiLink
                        component={RouterLink}
                        to={`/cihaz/${serviceRecord.cihazId}`}
                        sx={{ textDecoration: 'none', color: 'inherit' }}
                    >
                        <Typography><b>Seri No:</b> {serviceRecord.cihazSeriNumarasi}</Typography>
                    </MuiLink>
                    <Typography><b>Marka/Model:</b> {serviceRecord.cihazMarkaModel}</Typography>
                    <Typography><b>Cihaz Sınıfı:</b> {serviceRecord.cihazSinifi || '-'}</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>Servis Detayları</Typography>
                    <Divider sx={{ my: 1 }} />
                    <Grid container spacing={2}>
                        <Grid item xs={6} md={3}>
                            <Typography><b>Bakım Türü:</b> {serviceRecord.bakimTuru || '-'}</Typography>
                        </Grid>
                        <Grid item xs={6} md={3}>
                            <Typography><b>Oksijen (%):</b> {serviceRecord.oksijenOrani || '-'}</Typography>
                        </Grid>
                        <Grid item xs={6} md={3}>
                            <Typography><b>Basınç (mbar):</b> {serviceRecord.basincDegeri || '-'}</Typography>
                        </Grid>
                        <Grid item xs={6} md={3}>
                            <Typography><b>Çalışma Süresi:</b> {serviceRecord.calismaSuresi || '-'}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography><b>Genel Notlar:</b> {serviceRecord.servisNotlari || '-'}</Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Paper>
    );
};

export default ServiceDetailInfo;
